import { createFileRoute } from "@tanstack/react-router";
import AdminPartsNewsEdit from "@/pages/admin/AdminPartsNewsEdit";

export const Route = createFileRoute("/_adminLayout/admin/parts/news/$id")({
  component: AdminPartsNewsEdit,
});
